export { default } from "./Time";
export { default as timeReducer } from "./slice";
